import { useState } from "react"

export const Personalization = () => {
    const [bankForm, setBankForm] = useState({company_name: '', bank_id: '', account_name: '', account_number: '', error: false, saving: false, loader: true, agree: false, disabled: false, has_company_name: false})
    const [bankList, setBankList] = useState([])
    const [openBankForm, setOpenBankForm] = useState(false)
    const dfltBankForm = {company_name: '', bank_id: '', account_name: '', account_number: '', error: false, saving: false, loader: false, agree: false, disabled: false, has_company_name: false}
    // TERMS OF USE
    const [openTerms, setOpenTerms] = useState(false)
    const [agreedTerms, setAgreedTerms] = useState(false)
    const [hasAgreed, setHasAgreed] = useState(false)
    const [saveTermsConfirmation, setSaveTermsConfirmation] = useState({ modal: false, saving: false })
    const [fromNavigation, setFromNavigation] = useState(false);
    const [loaderTerms, setLoaderTerms] = useState(false)
    // WELCOME PERSONALIZATION
    const [open, setOpen] = useState({welcome: false, todo: false})

	// TOUR PERSONALIZATION 
	const [walkthrough, setWalkthrough] = useState({
        onboarding: false,
    })
    const [personalization, setPersonalization] = useState()
    const [startHere, setStartHere] = useState({show: true, modal: false, tasks: []},)

    return { 
        bankForm: {data:bankForm, set: setBankForm},
        bankList: {data:bankList, set: setBankList},
        openBankForm: {data:openBankForm, set: setOpenBankForm},
        dfltBankForm: {data: dfltBankForm},
        openTerms: {data:openTerms, set: setOpenTerms},
        agreedTerms: {data:agreedTerms, set: setAgreedTerms},
        hasAgreed: {data:hasAgreed, set: setHasAgreed},
        saveTermsConfirmation: {data: saveTermsConfirmation, set: setSaveTermsConfirmation},
        fromNavigation: {data: fromNavigation, set: setFromNavigation},
        loaderTerms: {data: loaderTerms, set: setLoaderTerms},
		walkthrough: {data: walkthrough, set: setWalkthrough},
        startHere: {data: startHere, set: setStartHere},
        personalization: {data: personalization, set: setPersonalization},
        open: {data: open, set: setOpen},
    }
}